import React, { useEffect, useState } from 'react';
import { List, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { ManageAccounts } from '@mui/icons-material';
import { useLocation, useNavigate } from 'react-router-dom';
import "./PermissionManagementNodeGroup.css";

export default function PermissionManagementNodeGroup(props) {

    const navigate = useNavigate();
    const state = useLocation();
    const [active, setActive] = useState();    

    useEffect(() => {
        const activeItemId = state && state.state && state.state.activeItemId;
        if(activeItemId) {
            setActive(activeItemId);
        }
    },[state]);

    return (
        <List component="div" disablePadding>
            <ListItemButton id="8001"
                className={(active === 8001) ? "kmc-console-permissionmgmt-litem-active" : ""}
                onClick={() => {
                    navigate('/manage/permissions', { state: { isPermissionsManagementNodeExpand: true } });
                    setActive(8001);
                }
                }>
                <ListItemIcon>
                    <ManageAccounts fontSize='medium' />
                </ListItemIcon>
                <ListItemText primary={'Manage Permissions'} />
            </ListItemButton>
        </List>
    )
}